import React, { useState } from "react";
import { Info, X } from "lucide-react";

export const ConfidenceBar = ({ score = 0, label = true }) => {
  const pct = Math.max(0, Math.min(100, score));
  const [showInfo, setShowInfo] = useState(false);

  return (
    <div data-testid="confidence-bar" className="w-full">
      {label && (
        <div className="flex items-center justify-between mb-2">
          <div className="flex items-center gap-2">
            <span className="text-xs font-semibold uppercase tracking-[0.18em] text-slate-500">
              Confidence
            </span>

            <button
              type="button"
              onClick={() => setShowInfo(true)}
              className="inline-flex items-center justify-center"
            >
              <Info className="w-4 h-4 text-slate-400 hover:text-[#356DFF]" />
            </button>
          </div>

          <span className="text-sm font-semibold text-slate-800">
            {pct}/100
          </span>
        </div>
      )}

      <div className="relative h-2.5 rounded-full bg-slate-100 overflow-hidden">
        <div
          className="absolute inset-y-0 left-0 rounded-full transition-all duration-500"
          style={{
            width: `${pct}%`,
            background:
              "linear-gradient(90deg, #ef4444 0%, #f59e0b 50%, #16a34a 100%)",
          }}
        />
      </div>

      {showInfo && (
        <div className="fixed inset-0 z-[99999] flex items-center justify-center bg-black/30 px-4">
          <div className="w-full max-w-sm rounded-[2rem] bg-white border border-slate-200 shadow-2xl p-5 relative">
            <button
              type="button"
              onClick={() => setShowInfo(false)}
              className="absolute top-4 right-4 rounded-full border border-slate-200 bg-white p-2"
            >
              <X className="w-4 h-4 text-slate-500" />
            </button>

            <h3 className="text-lg font-bold text-slate-900 pr-10">
              Confidence Score
            </h3>

            <p className="mt-2 text-sm text-slate-600 leading-6">
              This score helps estimate how reliable the provider information is.
            </p>

            <div className="mt-4 rounded-2xl bg-[#F8FBFF] border border-slate-200 p-4">
              <p className="text-xs font-bold text-slate-800 mb-2">
                Based on:
              </p>

              <ul className="space-y-2 text-sm text-slate-600">
                <li>• Public clinic information</li>
                <li>• Clinic website details</li>
                <li>• Community reports</li>
                <li>• Recent admin verification</li>
                <li>• Listing consistency checks</li>
              </ul>
            </div>

            <button
              type="button"
              onClick={() => setShowInfo(false)}
              className="mt-5 w-full rounded-2xl bg-gradient-to-r from-[#356DFF] to-[#5B8CFF] text-white py-3 font-semibold"
            >
              Got it
            </button>
          </div>
        </div>
      )}
    </div>
  );
};